define('shared/remote/payment/directDebit/pay',[
    '../ajax',
    'shared/lib/deepmerge',
    '../utils',
    './convertOptionsToPayload'
], function(
    ajax,
    deepmerge,
    utils,
    convertOptionsToPayload
){

    return function(options) {
        options = deepmerge({
            purchase: {}
        }, options);
        options.purchase.offers = utils.normalizeOffers(options.purchase.offers);
        var data = {
          'PurchaseInfo': {
            'Country': options.purchase.market,
            'Partner': options.purchase.partner,
            'Etag': options.purchase.etag,
            'Channel': 'Online',
            'Offer_ids': options.purchase.offers
          },
          'DirectDebitInfo': convertOptionsToPayload(options.directDebit)
        };

        return ajax({
                method: 'post',
                url: '/1/api/commerce-gateway/order/direct-debit-capture',
                data: data
            });
    };
});
